var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_36149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8281 9.16016V13.2324C13.8281 13.5555 13.5653 13.8184 13.2422 13.8184H1.75781C1.43473 13.8184 1.17188 13.5555 1.17188 13.2324V9.16016H0V13.2324C0 14.2017 0.788555 14.9902 1.75781 14.9902H13.2422C14.2114 14.9902 15 14.2017 15 13.2324V9.16016H13.8281Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50002 0.0117188L3.85889 3.65285L4.68752 4.48148L6.91408 2.25492V11.3872H8.08596V2.25492L10.3125 4.48148L11.1412 3.65285L7.50002 0.0117188Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_36149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b459e4391cb4ef0331f0e49d6353f756.svg";
export { ForwardRef as ReactComponent };